export enum Beoordeling {
    nietPluis = 'Niet pluis',
    nietTeBeoordelen = 'Niet te beoordelen',
    pluis = 'Pluis',
}

export const beoordelingOptions: Beoordeling[] = [
    Beoordeling.pluis,
    Beoordeling.nietPluis,
    Beoordeling.nietTeBeoordelen,
];

export enum ToestemmingVerstrekking {
    anders = 'Anders',
    hoortoestel = 'Hoortoestel',
    soloapparatuur = 'Soloapparatuur',
    wek_en_waarschuwingssysteem = 'Wek- en waarschuwingssysteem',
}

export const toestemmingVerstrekkingOptions: ToestemmingVerstrekking[] = [
    ToestemmingVerstrekking.hoortoestel,
    ToestemmingVerstrekking.wek_en_waarschuwingssysteem,
    ToestemmingVerstrekking.soloapparatuur,
    ToestemmingVerstrekking.anders,
];
